/* eslint-disable */
export const data = {
	mobile: [
		{
			name: 'cover-beach',
			src: '/assets/images/mobile/cover-beach.jpg',
		},
		{
			name: 'cover-night',
			src: '/assets/images/mobile/cover-night.jpg',
		},
	],
	desktop: [
		{
			name: 'cover-beach',
			src: '/assets/images/desktop/cover-beach.jpg',
		},
		{
			name: 'cover-night',
			src: '/assets/images/desktop/cover-night.jpg',
		},
	],
};

export default data;
